const rankings = [
  { rank: 1, title: '我独自升级', tag: '韩漫·热血', heat: '9.8', trend: 'up', change: '+2', desc: '本周新增收藏 28.6 万' },
  { rank: 2, title: '咒术回战', tag: '日漫·战斗', heat: '9.7', trend: 'stable', change: '—', desc: '本周新增收藏 21.3 万' },
  { rank: 3, title: '全知读者视角', tag: '韩漫·奇幻', heat: '9.6', trend: 'up', change: '+1', desc: '本周新增收藏 19.8 万' },
  { rank: 4, title: '剑尊归来', tag: '韩漫·武侠', heat: '9.5', trend: 'up', change: '+3', desc: '本周新增收藏 17.2 万' },
  { rank: 5, title: '鬼灭之刃', tag: '日漫·冒险', heat: '9.5', trend: 'down', change: '-1', desc: '本周新增收藏 15.6 万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-trophy-line"></i>
            <span>实时更新</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">人气榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">本周最受漫迷追捧的热门作品</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item) => (
            <a key={item.rank} href="#cards" className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group border-b border-background-200/40 last:border-b-0">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                {item.rank === 1 ? (
                  <i className="ri-medal-line text-2xl text-accent-500"></i>
                ) : item.rank === 2 ? (
                  <i className="ri-medal-line text-2xl text-secondary-400"></i>
                ) : item.rank === 3 ? (
                  <i className="ri-medal-line text-2xl text-primary-400"></i>
                ) : (
                  <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-lg font-bold text-primary-500">{item.heat}</div>
                <div className={`text-xs flex items-center justify-end gap-0.5 ${
                  item.trend === 'up' ? 'text-green-500' : item.trend === 'down' ? 'text-red-400' : 'text-foreground-400'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-s-line text-xs"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-s-line text-xs"></i>}
                  {item.change}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#cards" className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-200 text-foreground-600 text-sm font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}